module.exports = __webpack_public_path__ + "img/essilor-white.8966c3cf.svg";